import { useState, useCallback } from 'react'

const STORAGE_PREFIX = 'gracklecrm_recent_searches_'
const DEFAULT_MAX_ITEMS = 5

export function useRecentSearches(entityKey: string, maxItems = DEFAULT_MAX_ITEMS) {
  const storageKey = `${STORAGE_PREFIX}${entityKey}`

  const [recentSearches, setRecentSearches] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(storageKey)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  const addSearch = useCallback(
    (term: string) => {
      const trimmed = term.trim()
      if (trimmed.length < 2) return

      setRecentSearches((prev) => {
        const filtered = prev.filter((s) => s !== trimmed)
        const updated = [trimmed, ...filtered].slice(0, maxItems)
        try {
          localStorage.setItem(storageKey, JSON.stringify(updated))
        } catch {
          /* localStorage full — ignore */
        }
        return updated
      })
    },
    [storageKey, maxItems]
  )

  const clearSearches = useCallback(() => {
    setRecentSearches([])
    try {
      localStorage.removeItem(storageKey)
    } catch {
      /* ignore */
    }
  }, [storageKey])

  return { recentSearches, addSearch, clearSearches }
}
